// Auto-generated by javascript_version.py

export const DATETIME_STR = "2026-01-13 17:45";
export const VERSION_DATETIME = new Date(DATETIME_STR);

const VERSION = { DATETIME_STR, VERSION_DATETIME };
export default VERSION;
